export enum BusinessFileNames {
  VALID_IDS_OF_SIGNATORY = 'idsOfValidSignatories',
  VALID_IDS_OF_SIGNATORY_BACK = 'idsOfValidSignatoriesBack',
  VALID_IDS_OF_SIGNATORY_SIGNATURE = 'idsOfValidSignatoriesSignature',

  BARANGAY_BUSINESS_PERMIT = 'barangayBusinessPermit',
  BARANGAY_BUSINESS_PERMIT_BACK = 'barangayBusinessPermitBack',
  BARANGAY_BUSINESS_PERMIT_SIGNATURE = 'barangayBusinessPermitSignature',

  STORE_PHOTO_WITH_STORE_NAME = 'storePhoto',

  MAYORS_OR_BUSINESS_PERMIT = 'mayorsOrBusinessPermit',
  MAYORS_OR_BUSINESS_PERMIT_BACK = 'mayorsOrBusinessPermitBack',
  MAYORS_OR_BUSINESS_PERMIT_SIGNATURE = 'mayorsOrBusinessPermitSignature',

  BIR_CERTIFICATE_2303 = 'birCert2303',
  BIR_CERTIFICATE_2303_BACK = 'birCert2303Back',
  BIR_CERTIFICATE_2303_SIGNATURE = 'birCert2303Signature',

  SEC_CERTIFICATE = 'secCert',
  SEC_CERTIFICATE_BACK = 'secCertBack',
  SEC_CERTIFICATE_SIGNATURE = 'secCertSignature',

  AOI_AND_BY_LAWS = 'aoiAndByLaws',
  AOI_AND_BY_LAWS_BACK = 'aoiAndByLawsBack',
  AOI_AND_BY_LAWS_SIGNATURE = 'aoiAndByLawsSignature',

  GIS = 'gis',
  GIS_BACK = 'gisBack',
  GIS_SIGNATURE = 'gisSignature',

  SECRETARYS_CERTIFICATE = 'secretarysCert',
  SECRETARYS_CERTIFICATE_BACK = 'secretarysCertBack',
  SECRETARYS_CERTIFICATE_SIGNATURE = 'secretarysCertSignature',
}

export enum BusinessFileNamesReadable {
  VALID_IDS_OF_SIGNATORY = 'Valid ID of Signatory',
  VALID_IDS_OF_SIGNATORY_BACK = 'Valid ID of Signatory (Back)',
  VALID_IDS_OF_SIGNATORY_SIGNATURE = 'Valid ID of Signatory (Signature)',

  BARANGAY_BUSINESS_PERMIT = 'Barangay Business Permit',
  BARANGAY_BUSINESS_PERMIT_BACK = 'Barangay Business Permit (Back)',
  BARANGAY_BUSINESS_PERMIT_SIGNATURE = 'Barangay Business Permit (Signature)',

  STORE_PHOTO_WITH_STORE_NAME = 'Photo of Store with Store Name',

  MAYORS_OR_BUSINESS_PERMIT = "Mayor's / Business Permit",
  MAYORS_OR_BUSINESS_PERMIT_BACK = "Mayor's / Business Permit (Back)",
  MAYORS_OR_BUSINESS_PERMIT_SIGNATURE = "Mayor's / Business Permit (Signature)",

  BIR_CERTIFICATE_2303 = 'BIR Certificate 2303',
  BIR_CERTIFICATE_2303_BACK = 'BIR Certificate 2303 (Back)',
  BIR_CERTIFICATE_2303_SIGNATURE = 'BIR Certificate 2303 (Signature)',

  SEC_CERTIFICATE = 'SEC Certificate',
  SEC_CERTIFICATE_BACK = 'SEC Certificate (Back)',
  SEC_CERTIFICATE_SIGNATURE = 'SEC Certificate (Signature)',

  AOI_AND_BY_LAWS = 'AOI and By-Laws',
  AOI_AND_BY_LAWS_BACK = 'AOI and By-Laws (Back)',
  AOI_AND_BY_LAWS_SIGNATURE = 'AOI and By-Laws (Signature)',

  GIS = 'GIS',
  GIS_BACK = 'GIS (Back)',
  GIS_SIGNATURE = 'GIS (Signature)',

  SECRETARYS_CERTIFICATE = "Secretary's Certificate",
  SECRETARYS_CERTIFICATE_BACK = "Secretary's Certificate (Back)",
  SECRETARYS_CERTIFICATE_SIGNATURE = "Secretary's Certificate (Signature)",
}
